import React from "react";
import { useStore } from "effector-react";
import { $queue } from "../store/guestsStore";
import GuestCard from "./GuestCard";
import "./NewGuests.css"; // Import the new CSS file

const NewGuests = () => {
  const queue = useStore($queue);

  return (
    <div className="new-guests-container">
      <h2 className="new-guests-title">Новые гости</h2>
      <div className="new-guests-list">
        {queue.length > 0 ? (
          queue.map((guest) => (
            <div key={guest.id} className="flex-shrink-0 w-80">
              <GuestCard guest={guest} />
            </div>
          ))
        ) : (
          <p className="text-gray-500 text-center w-full">Пока нет гостей...</p>
        )}
      </div>
    </div>
  );
};

export default NewGuests;
